import { ErrorMessage } from 'formik';

import { FormHelp } from '@zillow/constellation-10';

type Props = {
  name: string;
};

const FormikErrorMessage = ({ name }: Props) => {
  return (
    <ErrorMessage name={name}>
      {(msg: string) => <FormHelp error>{msg.charAt(0).toUpperCase() + msg.slice(1)}</FormHelp>}
    </ErrorMessage>
  );
};

export default FormikErrorMessage;
